import {User} from '../types';

export const getUserFullName = (user: User): string => {
  if (!user.firstName && !user.lastName) {
    return user.email;
  }

  return `${user.firstName} ${user.lastName}`.trim();
};
